import { toFullUrl } from '../url/to-full-url'
import { getCommonRouter } from './get-common-router'

export function navigateInternally(href: string) {
  const fullHref = toFullUrl(href)
  const url = new URL(fullHref)
  if (url.origin !== window.location.origin) return false

  const router = getCommonRouter()
  if (!router) return false

  let routerHref = url.pathname + url.search + url.hash
  let fullscreenChatBaseUrl = import.meta.env.VITE_FULLSCREEN_CHAT_BASE_URL
  if (fullscreenChatBaseUrl === '/') fullscreenChatBaseUrl = ''

  if (fullscreenChatBaseUrl && routerHref.startsWith(fullscreenChatBaseUrl)) {
    routerHref = routerHref.replace(fullscreenChatBaseUrl, '')
  }

  router.push(routerHref)

  return true
}
